var exports = {
  "kL": "ChannelDivider.module__container___TVQyNm",
  "JW": "ChannelDivider.module__unreadContainer___TVQyNm",
  "iN": "ChannelDivider.module__unreadDate___TVQyNm",
  "n8": "ChannelDivider.module__line___TVQyNm",
  "Qq": "ChannelDivider.module__text___TVQyNm",
  "KQ": "ChannelDivider.module__unreadLine___TVQyNm",
  "vD": "ChannelDivider.module__dateWithUnreadText___TVQyNm",
  "HN": "ChannelDivider.module__unreadBadge___TVQyNm",
};

module.exports = exports;
